// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pC4n","placeholdersHeader":"styles_placeholdersHeader__DSt7W","editorStyle":"styles_editorStyle__3XQJ7","placeholdersBox":"styles_placeholdersBox__3TMX_"};